import { render, staticRenderFns } from "./PromotionPage.vue?vue&type=template&id=554d1d07&scoped=true&"
import script from "./PromotionPage.vue?vue&type=script&lang=js&"
export * from "./PromotionPage.vue?vue&type=script&lang=js&"
import style0 from "./PromotionPage.vue?vue&type=style&index=0&id=554d1d07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554d1d07",
  null
  
)

export default component.exports